module.exports = __webpack_public_path__ + "img/green-triangle.298a1f05.svg";